import { get } from 'lodash';

export class BMICheckRequest {
  weight: string;
  height: string;
  age: string;
  comp: string;
  prodcode: string;
  constructor(initial: any) {
    this.weight = get(initial, 'weight', '');
    this.height = get(initial, 'height', '');
    this.age = get(initial, 'age', '');
    this.comp = get(initial, 'comp', 'LIF');
    this.prodcode = get(initial, 'prodcode', 'SIO/DPI');
  }
}